import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import pl from './pl.json';

export type LanguageType = 'en' | 'pl';

const savedLanguage = localStorage.getItem('hustleLanguage') as LanguageType | null;

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        pl: { translation: pl },
    },
    lng: savedLanguage || 'en',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    pluralSeparator: '_',
});

export default i18n;
